// Add custom code below this line
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

if (!customElements.get("hc-product-group")) {
  class HCProductGroup extends HTMLElement {
    constructor() {
      super();
      this.debugPrefix = "[hc-product-group]";
      this.onChangeVariantIdBound = this.onChangeVariantId.bind(this);
      this.inputID = document.querySelector('input[name="id"]');
      this.ProductGroupMaster = this;
      this.activeItems = this.querySelectorAll(".selected");
      if (this.inputID) {
        this.inputID.addEventListener("change", this.onChangeVariantIdBound);
      }

      this.onProductReloadBound = this.onProductReload.bind(this);
      window.addEventListener("hcProductReload", this.onProductReloadBound);

      this.init();
    }

    disconnectedCallback() {
      if (this.inputID && this.onChangeVariantIdBound) {
        this.inputID.removeEventListener("change", this.onChangeVariantIdBound);
      }
      if (this.onProductReloadBound) {
        window.removeEventListener("hcProductReload", this.onProductReloadBound);
      }
    }

    init() {
      const currentVariant = window.currentVariant;
      this.updateVariant(currentVariant);
    }

    onChangeVariantId(e) {
      const variantID = e.target.value;
      const variants = window.globalProduct?.variants || [];
      const currentVariant = variants.find(
        (v) => v.id == variantID
      );

      if (!currentVariant) return;
      this.updateVariant(currentVariant);

      this.dispatchEvent(
        new CustomEvent("hcChangeVariantId", {
          detail: {
            currentVariant,
          },
        })
      );
    }

    updateVariant(currentVariant) {
      if (!currentVariant) return;
      this.activeItems.forEach((element) => {
        const itemPrice = element.querySelector(".product__price");
        const savingPrice = element.querySelector(".saving-price");
        if (savingPrice) {
          const baseVariantPrice = currentVariant.price * 1;
          let productPrice = baseVariantPrice;
          let productComparePrice = currentVariant.compare_at_price * 1;
          const discountPercentageAttr =
            savingPrice.dataset && savingPrice.dataset.discountPercentage
              ? parseFloat(savingPrice.dataset.discountPercentage)
              : NaN;
          const hasDiscountOverride =
            !Number.isNaN(discountPercentageAttr) &&
            discountPercentageAttr > 0 &&
            discountPercentageAttr < 100;

          if (hasDiscountOverride) {
            const denominator = 100 - discountPercentageAttr;
            if (denominator > 0) {
              productComparePrice = baseVariantPrice;
              productPrice = Math.round(
                (productComparePrice * denominator) / 100
              );
            }
          } else {
            if (!productComparePrice || productComparePrice <= productPrice) {
              productComparePrice = 0;
            }
          }

          if (savingPrice.dataset) {
            savingPrice.dataset.price = `${productPrice}`;
            savingPrice.dataset.comparePrice = `${productComparePrice}`;
            if (hasDiscountOverride) {
              savingPrice.dataset.discountPercentage = `${discountPercentageAttr}`;
            }
          }

          const hasValidCompare =
            productComparePrice &&
            productComparePrice > productPrice;

          const formattedPrice = Shopify.formatMoney(
            productPrice,
            window.theme.moneyFormat
          );
          if (itemPrice) {
            itemPrice.textContent = formattedPrice;
          }

          const customsProductPrice = savingPrice.querySelectorAll(
            ".custom-product-price"
          );

          customsProductPrice.forEach(function (customProductPrice) {
            if (customProductPrice) {
              const priceType = customProductPrice.classList.contains("custom-price")
                ? "price"
                : customProductPrice.classList.contains("custom-compare-price")
                ? "compare"
                : customProductPrice.classList.contains("custom-saving-price")
                ? "saving"
                : customProductPrice.classList.contains("custom-saving-percent")
                ? "saving-percent"
                : "unknown";
              if (customProductPrice.classList.contains("custom-price")) {
                customProductPrice.textContent = Shopify.formatMoney(
                  productPrice,
                  window.theme.moneyFormat
                );
              }

              if (
                customProductPrice.classList.contains("custom-compare-price")
              ) {
                if (hasValidCompare) {
                  customProductPrice.textContent = Shopify.formatMoney(
                    productComparePrice,
                    window.theme.moneyFormat
                  );
                } else {
                  customProductPrice.textContent = Shopify.formatMoney(
                    productPrice,
                    window.theme.moneyFormat
                  );
                }
              }

              if (
                customProductPrice.classList.contains("custom-saving-price")
              ) {
                const savingValue = hasValidCompare
                  ? productComparePrice - productPrice
                  : 0;
                customProductPrice.textContent = Shopify.formatMoney(
                  savingValue,
                  window.theme.moneyFormat
                );
              }

              if (customProductPrice.classList.contains("custom-saving-percent")) {
                let savingPercent = "0%";
                if (hasValidCompare) {
                  if (hasDiscountOverride) {
                    savingPercent = `${Math.round(
                      discountPercentageAttr
                    )}%`;
                  } else {
                    savingPercent = `${Math.round(
                      ((productComparePrice - productPrice) * 100) /
                        productComparePrice
                    )}%`;
                  }
                }
                customProductPrice.textContent = savingPercent;
              }

            }
          });
        }
      });
    }

    onProductReload(event) {
      const detail = event?.detail || {};
      const currentVariant = detail.currentVariant || window.currentVariant;
      const productComponent = detail.productComponent;
      const newInput = productComponent?.querySelector('input[name="id"]');

      if (this.inputID && this.onChangeVariantIdBound) {
        this.inputID.removeEventListener("change", this.onChangeVariantIdBound);
      }

      this.inputID = newInput || null;
      if (this.inputID) {
        this.inputID.addEventListener("change", this.onChangeVariantIdBound);
      }

      this.updateVariant(currentVariant);
    }
  }

  customElements.define("hc-product-group", HCProductGroup);

  if (!customElements.get("hc-variant-radios")) {
    customElements.define(
      "hc-variant-radios",
      class VariantRadios extends HTMLElement {
        constructor() {
          super();
          this.radioInputs = document.querySelectorAll(
            ".radio__buttons .radio__button input"
          );
          this.radioInputs.forEach((element) => {
            element.addEventListener(
              "change",
              this.onChangeVariantInput.bind(this)
            );
          });

          this.init();

          document.addEventListener("shopify:section:load", function (event) {
            const currentVariant = window.currentVariant;
            setTimeout(() => {
              this.updateVariantElement(currentVariant);
            }, 500);
          });
        }

        init() {
          const currentVariant = window.currentVariant;

          this.updateVariantElement(currentVariant);
        }

        onChangeVariantInput(e) {
          const variantID =
            document.querySelector('input[name="id"]')?.value || "";
          const currentVariant = window.globalProduct.variants.find(
            (v) => v.id == variantID
          );
          if (currentVariant) this.updateVariantElement(currentVariant);
        }

        updateVariantElement(currentVariant) {
          const optionOther1 = currentVariant.option1;
          const optionOther2 = currentVariant.option2;
          const optionOther3 = currentVariant.option3;
          const productData = window.globalProduct;
          const selectorWrapper =
            document.querySelectorAll(".selector-wrapper");
          for (let index = 0; index < selectorWrapper.length; index++) {
            const wrapper = selectorWrapper[index];
            const position = wrapper?.getAttribute("data-option-position") || 0;
            const buttons = wrapper.querySelectorAll(".radio__button") || [];
            for (let index = 0; index < buttons.length; index++) {
              const button = buttons[index];
              const input = button.querySelector("input");
              const value = input?.value || "";
              const priceEle = button.querySelector(".variant-price__value");
              const matchedVariant = productData.variants.find((variant) => {
                if (position == "1") {
                  return (
                    variant.option1 == value &&
                    variant.option2 == optionOther2 &&
                    variant.option3 == optionOther3
                  );
                } else if (position == "2") {
                  return (
                    variant.option1 == optionOther1 &&
                    variant.option2 == value &&
                    variant.option3 == optionOther3
                  );
                } else if (position == "3") {
                  return (
                    variant.option1 == optionOther1 &&
                    variant.option2 == optionOther2 &&
                    variant.option3 == value
                  );
                }
                return false;
              });

              if (matchedVariant) {
                const formattedPrice = Shopify.formatMoney(
                  matchedVariant.price,
                  window.theme.moneyFormat
                );
                if (matchedVariant.available) {
                  button.classList.remove("disabled");
                } else {
                  button.classList.add("disabled");
                }
                if (priceEle) priceEle.textContent = formattedPrice;
              }
            }
          }
        }
      }
    );
  }

  if (!customElements.get("hc-carousel")) {
    customElements.define(
      "hc-carousel",
      class ProductGroupCarousel extends HTMLElement {
        constructor() {
          super();
          this.track = this.querySelector(".carousel-track");
          this.prevBtn = this.querySelector(".carousel-button.prev");
          this.nextBtn = this.querySelector(".carousel-button.next");
          this.items = this.querySelectorAll(".carousel-item");
          this.itemWidth = 0;
          this.activeItem = this.querySelector(".selected .carousel-item");
          this.handleResizeBound = this.handleResize.bind(this);
    
          // Touch/drag variables
          this.touchStartX = 0;
          this.touchStartY = 0;
          this.touchEndX = 0;
          this.touchEndY = 0;
          this.isDragging = false;
          this.dragStartX = 0;
          this.currentTranslate = 0;
          this.prevTranslate = 0;
          this.animationID = 0;
          this.velocity = 0;
          this.lastTime = 0;
          this.lastPosition = 0;
          this.isHorizontalSwipe = false;
    
          this.init();
    
          this.prevBtn?.addEventListener("click", this.onClickPrev.bind(this));
          this.nextBtn?.addEventListener("click", this.onClickNext.bind(this));
    
          // Touch events
          this.track.addEventListener(
            "touchstart",
            this.handleTouchStart.bind(this),
            { passive: true }
          );
          this.track.addEventListener(
            "touchmove",
            this.handleTouchMove.bind(this),
            { passive: false }
          );
          this.track.addEventListener(
            "touchend",
            this.handleTouchEnd.bind(this)
          );
    
          // Mouse events
          this.track.addEventListener(
            "mousedown",
            this.handleMouseDown.bind(this)
          );
          window.addEventListener("mousemove", this.handleMouseMove.bind(this));
          window.addEventListener("mouseup", this.handleMouseUp.bind(this));
    
          // Disable drag image
          this.track.addEventListener("dragstart", (e) => e.preventDefault());

          window.addEventListener("resize", this.handleResizeBound);
          // Recalculate when images load (initially width can be 0 on fresh load)
          this.items.forEach((item) => {
            const img = item.querySelector("img");
            if (img) {
              img.addEventListener("load", () => {
                this.calculateItemWidth(true);
              });
            }
          });
        }
    
        init() {
          this.calculateItemWidth();
          this.visibleCount = Math.max(
            1,
            Math.floor(this.offsetWidth / this.itemWidth)
          );
          this.currentIndex = 0;
          if (this.activeItem) {
            const currentPosistion = Array.from(this.items).indexOf(
              this.activeItem
            );
            if (currentPosistion * 1 > this.visibleCount) {
              this.currentIndex = currentPosistion * 1 - 1;
            }
          }
    
          this.updateCarousel(false);
        }

        handleResize() {
          this.calculateItemWidth(true);
        }

        calculateItemWidth(force = false) {
          if (!force && this.itemWidth > 0) return;

          const cssWidth = parseInt(
            window
              .getComputedStyle(this)
              .getPropertyValue("--carousel-item-width")
          );
          const measured =
            (this.items?.[0]?.getBoundingClientRect().width || 0) || 0;
          const baseWidth = measured || cssWidth || 150;
          this.itemWidth = baseWidth + 10; // include gap
          this.visibleCount = Math.max(
            1,
            Math.floor(this.offsetWidth / this.itemWidth)
          );
          this.updateCarousel(false);
        }
    
        updateCarousel(withAnimation = true) {
          const offset = this.currentIndex * this.itemWidth;
          this.prevTranslate = this.currentTranslate;
          this.currentTranslate = -offset;
    
          if (withAnimation) {
            this.track.style.transition =
              "transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
            this.track.style.transform = `translateX(${this.currentTranslate}px)`;
          } else {
            this.track.style.transition = "none";
            this.track.style.transform = `translateX(${this.currentTranslate}px)`;
          }
    
          // Update buttons visibility
          this.prevBtn.style.display =
            this.currentIndex === 0 ? "none" : "flex";
          this.nextBtn.style.display =
            this.currentIndex >= this.items.length - this.visibleCount
              ? "none"
              : "flex";
        }
    
        onClickNext(e) {
          e.preventDefault();
          if (this.currentIndex < this.items.length - this.visibleCount) {
            this.currentIndex++;
            this.updateCarousel();
          }
        }
    
        onClickPrev(e) {
          e.preventDefault();
          if (this.currentIndex > 0) {
            this.currentIndex--;
            this.updateCarousel();
          }
        }
    
        getPositionX(event) {
          return event.type.includes("mouse")
            ? event.clientX
            : event.touches[0].clientX;
        }
    
        getPositionY(event) {
          return event.type.includes("mouse")
            ? event.clientY
            : event.touches[0].clientY;
        }
    
        handleTouchStart(e) {
          this.touchStartX = this.getPositionX(e);
          this.touchStartY = this.getPositionY(e);
          this.isDragging = true;
          this.isHorizontalSwipe = false;
          this.dragStartX = this.touchStartX;
          this.lastPosition = this.currentTranslate;
          this.lastTime = performance.now();
          this.velocity = 0;
    
          cancelAnimationFrame(this.animationID);
          this.track.style.transition = "none";
        }
    
        handleTouchMove(e) {
          if (!this.isDragging) return;
          
          const currentX = this.getPositionX(e);
          const currentY = this.getPositionY(e);
          
          // Check if it's a horizontal swipe
          if (!this.isHorizontalSwipe) {
            const diffX = Math.abs(currentX - this.touchStartX);
            const diffY = Math.abs(currentY - this.touchStartY);
            
            // If vertical movement is greater than horizontal, ignore the swipe
            if (diffY > diffX) {
              this.isDragging = false;
              return;
            }
            this.isHorizontalSwipe = true;
          }
          
          e.preventDefault();
    
          const diff = currentX - this.touchStartX;
          this.touchStartX = currentX;
    
          // Calculate velocity for inertia effect
          const currentTime = performance.now();
          const timeDiff = currentTime - this.lastTime;
          if (timeDiff > 0) {
            this.velocity =
              (this.currentTranslate - this.lastPosition) / timeDiff;
            this.lastPosition = this.currentTranslate;
            this.lastTime = currentTime;
          }
    
          this.currentTranslate += diff;
    
          // Apply boundaries
          const maxTranslate = 0;
          const minTranslate = -(this.items.length - 1) * this.itemWidth;
          this.currentTranslate = Math.min(
            Math.max(this.currentTranslate, minTranslate),
            maxTranslate
          );
    
          this.track.style.transform = `translateX(${this.currentTranslate}px)`;
        }
    
        handleTouchEnd() {
          if (!this.isDragging || !this.isHorizontalSwipe) return;
          this.isDragging = false;
    
          // Apply inertia
          const momentum = this.velocity * 100;
          let targetTranslate = this.currentTranslate + momentum;
    
          // Snap to nearest slide
          const slideWidth = this.itemWidth;
          const snapIndex = Math.round(-targetTranslate / slideWidth);
          this.currentIndex = Math.max(
            0,
            Math.min(snapIndex, this.items.length - this.visibleCount)
          );
    
          this.updateCarousel();
        }
    
        handleMouseDown(e) {
          e.preventDefault();
          this.isDragging = true;
          this.dragStartX = this.getPositionX(e);
          this.lastPosition = this.currentTranslate;
          this.lastTime = performance.now();
          this.velocity = 0;
    
          cancelAnimationFrame(this.animationID);
          this.track.style.transition = "none";
          this.track.style.cursor = "grabbing";
        }
    
        handleMouseMove(e) {
          if (!this.isDragging) return;
    
          const currentX = this.getPositionX(e);
          const diff = currentX - this.dragStartX;
          this.dragStartX = currentX;
    
          // Calculate velocity
          const currentTime = performance.now();
          const timeDiff = currentTime - this.lastTime;
          if (timeDiff > 0) {
            this.velocity =
              (this.currentTranslate - this.lastPosition) / timeDiff;
            this.lastPosition = this.currentTranslate;
            this.lastTime = currentTime;
          }
    
          this.currentTranslate += diff;
    
          // Apply boundaries
          const maxTranslate = 0;
          const minTranslate = -(this.items.length - 1) * this.itemWidth;
          this.currentTranslate = Math.min(
            Math.max(this.currentTranslate, minTranslate),
            maxTranslate
          );
    
          this.track.style.transform = `translateX(${this.currentTranslate}px)`;
        }
    
        handleMouseUp() {
          if (!this.isDragging) return;
          this.isDragging = false;
          this.track.style.cursor = "grab";
    
          // Apply inertia
          const momentum = this.velocity * 150; // Slightly more momentum for mouse
          let targetTranslate = this.currentTranslate + momentum;
    
          // Snap to nearest slide
          const slideWidth = this.itemWidth;
          const snapIndex = Math.round(-targetTranslate / slideWidth);
          this.currentIndex = Math.max(
            0,
            Math.min(snapIndex, this.items.length - this.visibleCount)
          );
    
          this.updateCarousel();
        }

        disconnectedCallback() {
          window.removeEventListener("resize", this.handleResizeBound);
        }
      }
    );
  }

  if (!customElements.get("hc-collapsible")) {
    customElements.define(
      "hc-collapsible",
      class ProductGroupCollapsible extends HTMLElement {
        constructor() {
          super();
          this.collapsible = this.querySelector(".collapsible");

          if (this.collapsible) {
            this.content = this.collapsible.nextElementSibling;
            this.innerContent = this.content.querySelector(".content__inner");
            this.collapsible.addEventListener(
              "click",
              this.onClickTitle.bind(this)
            );
          }
        }

        onClickTitle(e) {
          this.collapsible = this.querySelector(".collapsible");
          const button = this.collapsible;
          const isExpanded = button.getAttribute("aria-expanded") === "true";
          button.setAttribute("aria-expanded", !isExpanded);

          if (!isExpanded) {
            const innerHeight =
              this.innerContent.getBoundingClientRect().height;
            this.content.style.height = `${innerHeight}px`;

            const onTransitionEnd = () => {
              this.content.removeEventListener(
                "transitionend",
                onTransitionEnd
              );
              this.content.style.overflow = "visible";
            };
            this.content.addEventListener("transitionend", onTransitionEnd);
          } else {
            this.content.style.overflow = "hidden";
            this.content.style.height = "0px";
          }
        }
      }
    );
  }

  if (!customElements.get("hc-show-more-items")) {
    customElements.define(
      "hc-show-more-items",
      class ShowMoreItems extends HTMLElement {
        constructor() {
          super();
          const self = this;
          this.moreItemButton = this.querySelector(".more-items-btn");
          this.activeItem = this.querySelector(".selected");
          this.items = this.querySelectorAll(".product-group__item");

          if (this.items.length > 5) {
            this.items.forEach(function (item, index) {
              if (index > 3) {
                item.classList.add("product-hidden");
              }
            });
          }

          if (this.moreItemButton) {
            this.moreItemButton.addEventListener(
              "click",
              this.onClickShowMoreItems.bind(this)
            );
          }

          if (this.activeItem) {
            this.classList.add("expanded");
          }
        }

        onClickShowMoreItems(e) {
          e.preventDefault();
          e.stopPropagation();
          this.classList.toggle("expanded");
        }
      }
    );
  }
}

// AJAX chuyển đổi sản phẩm trong product-group mà không reload trang
// DISABLED: Let links navigate normally for better compatibility with different templates
document.addEventListener("click", function (event) {
  const link = event.target.closest("a.product-group__item");
  if (!link) return;

  // DISABLED: Always allow normal navigation (full page reload)
  // This ensures proper template loading when switching between products
  // with different templates (e.g., small-le → leather-handbag)
  return;

  const handle = link.dataset.productHandle;
  if (!handle) return;

  const productComponent = document.querySelector(
    'product-component[data-section-type="product"]'
  );
  if (!productComponent) return;

  const ajaxEnabled = productComponent.dataset.productGroupAjaxEnable;
  if (ajaxEnabled !== "true") return;

  const sectionId = productComponent.dataset.sectionId;
  if (!sectionId) return;

  event.preventDefault();

  const requestUrl = `/products/${handle}?section_id=${sectionId}`;
  const productGroupRoot = link.closest(".product-group");

  if (productGroupRoot) {
    productGroupRoot.classList.add("product-group--loading");
  }

  fetch(requestUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to load product section: ${response.status}`);
      }
      return response.text();
    })
    .then((html) => {
      const container = document.createElement("div");
      container.innerHTML = html;

      let newProductComponent =
        container.querySelector(
          `product-component[data-section-id="${sectionId}"]`
        ) || container.querySelector(`[data-section-id="${sectionId}"]`);

      if (!newProductComponent) return;

      // Cập nhật window.globalProduct & window.currentVariant từ JSON trong section mới
      window.globalProduct = null;
      window.currentVariant = null;
      const productJsonElement =
        newProductComponent.querySelector("[data-product-json]");
      if (productJsonElement && productJsonElement.innerHTML.trim()) {
        try {
          const productData = JSON.parse(productJsonElement.innerHTML);
          window.globalProduct = productData;

          const idInput =
            newProductComponent.querySelector('input[name="id"]');
          let currentVariant = null;

          if (idInput && idInput.value) {
            const variantId = idInput.value;
            currentVariant = productData.variants.find(
              (variant) => String(variant.id) === String(variantId)
            );
          }

          if (!currentVariant && productData.variants?.length) {
            currentVariant = productData.variants[0];
          }

          window.currentVariant = currentVariant || null;
        } catch (error) {
          console.error("Failed to parse product JSON", error);
        }
      }

      // CRITICAL: Load external scripts and execute inline scripts from loaded HTML
      // Scripts don't execute when inserted via innerHTML, must manually process them

      // Helper function to load external script and return a promise
      const loadExternalScript = (src) => {
        // Check if script already exists
        if (document.querySelector(`script[src="${src}"]`)) {
          return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      };

      // Load CSS stylesheets from the new content
      const stylesheets = container.querySelectorAll('link[rel="stylesheet"]');
      stylesheets.forEach(link => {
        const href = link.getAttribute('href');
        if (href && !document.querySelector(`link[href="${href}"]`)) {
          const newLink = document.createElement('link');
          newLink.rel = 'stylesheet';
          newLink.href = href;
          document.head.appendChild(newLink);
        }
      });

      // Collect external scripts to load
      const externalScripts = container.querySelectorAll('script[src]');
      const scriptPromises = Array.from(externalScripts).map(script => {
        const src = script.getAttribute('src');
        return loadExternalScript(src).catch(e => console.warn('Failed to load script:', src, e));
      });

      // Wait for all external scripts to load, then execute inline scripts
      Promise.all(scriptPromises).then(() => {
        // Execute inline scripts (data setup)
        const inlineScripts = container.querySelectorAll('script:not([src])');
        inlineScripts.forEach(oldScript => {
          try {
            const newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach(attr => {
              newScript.setAttribute(attr.name, attr.value);
            });
            newScript.textContent = oldScript.textContent;
            document.body.appendChild(newScript);
            newScript.remove();
          } catch (e) {
            console.warn('Failed to execute inline script:', e);
          }
        });

        // Now insert the new component (custom elements will have their data ready)
        productComponent.replaceWith(newProductComponent);

        const targetUrl = link.getAttribute("href");
        if (targetUrl && window.history && window.history.replaceState) {
          window.history.replaceState({}, "", targetUrl);
        }

        window.dispatchEvent(
          new CustomEvent("hcProductReload", {
            detail: {
              currentVariant: window.currentVariant,
              productComponent: newProductComponent,
            },
          })
        );

        // Remove loading state after everything is done
        if (productGroupRoot) {
          productGroupRoot.classList.remove("product-group--loading");
        }
      }).catch(err => {
        console.error('Failed to process scripts:', err);
        // Still insert the component even if scripts fail
        productComponent.replaceWith(newProductComponent);
        if (productGroupRoot) {
          productGroupRoot.classList.remove("product-group--loading");
        }
      });
    })
    .catch((error) => {
      console.error(error);
      if (productGroupRoot) {
        productGroupRoot.classList.remove("product-group--loading");
      }
    });
});

// <hc-collapsible class="collapsible-group group-type__collapsible group-type__container">
//         <button class="collapsible" aria-expanded="true">
//           <span class="collapsible__title">
//             <div class="product-group-title">
//               {{ group.title }}
//               {% if current_product and group.show_option_name == true -%}
//                 <span class="option-name"> - {{ current_product.title }}</span>
//               {%- endif %}
//             </div>
//           </span>
//           <svg class="collapsible__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
//           </svg>
//         </button>
//         <div class="content" aria-hidden="true">
//           <div class="content__inner">
//             {% for item in group.products.value %}
//               {% assign product_in_group = item.product.value %}
//               {% if product_in_group.handle == product.handle %}
//                 <a href="{{ product_in_group.url }}">
//                   <div class="carousel-item {% if product_in_group.available == false %}disabled{% endif %} {% if product_in_group.handle == product.handle %}selected{% endif %}">
//                     {% if item.media.value %}
//                       <img
//                         src="{{ item.media.value | img_url: 'large' }}"
//                         alt="{{ item.media.value.alt | escape }}"
//                         loading="lazy"
//                         width="200"
//                         height="200"
//                       >
//                     {% else %}
//                       <img
//                         src="{{ product_in_group.featured_image | img_url: 'large' }}"
//                         alt="{{ product_in_group.featured_image.alt | escape }}"
//                         loading="lazy"
//                         width="200"
//                         height="200"
//                       >
//                     {% endif %}

//                     <div class="carousel-item__content">
//                       <div class="carousel-item__title">
//                         {{ item.title }}
//                       </div>
//                       <div class="carousel-item__price">
//                         {{ product_in_group.price | money }}
//                       </div>
//                     </div>
//                   </div>
//                 </a>
//               {% endif %}
//             {% endfor %}

//             {% for item in group.products.value %}
//               {% assign product_in_group = item.product.value %}
//               {% if product_in_group.handle != product.handle %}
//                 <a href="{{ product_in_group.url }}">
//                   <div class="carousel-item {% if product_in_group.available == false %}disabled{% endif %} {% if product_in_group.handle == product.handle %}selected{% endif %}">
//                     {% if item.media.value %}
//                       <img
//                         src="{{ item.media.value | img_url: 'large' }}"
//                         alt="{{ item.media.value.alt | escape }}"
//                         loading="lazy"
//                         width="200"
//                         height="200"
//                       >
//                     {% else %}
//                       <img
//                         src="{{ product_in_group.featured_image | img_url: 'large' }}"
//                         alt="{{ product_in_group.featured_image.alt | escape }}"
//                         loading="lazy"
//                         width="200"
//                         height="200"
//                       >
//                     {% endif %}

//                     <div class="carousel-item__content">
//                       <div class="carousel-item__title">
//                         {{ item.title }}
//                       </div>
//                       <div class="carousel-item__price">
//                         {{ product_in_group.price | money }}
//                       </div>
//                     </div>
//                   </div>
//                 </a>
//               {% endif %}
//             {% endfor %}
//           </div>
//         </div>
//       </hc-collapsible>
